const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  const extraSmallCardHeight = 18;
  const squareCardHeight = 30;
  const smallCardHeight = 38;
  const cardHeight = 50;
  const cardRatio = 1;
  const borderRatio = 1.15;

  const reflectionWidth = '70%';
  const reflectionHeight = '108%';
  const reflectionDuration = '2s';

  const reflectionStyle = {
    content: '""',
    position: 'absolute',
    width: reflectionWidth,
    height: reflectionHeight,
    background: 'transparent',
    transform: 'translateX(50%) skewX(-35deg)',
    animationDuration: reflectionDuration,
    animationIterationCount: 'infinite',
  };

  return {
    cardContainer: {
      display: 'block',
      minWidth: 0,
      transition: 'bottom 0.3s, filter 0.3s',
      position: 'relative',
      bottom: 0,
      filter: 'brightness(100%)',
    },
    '@keyframes reflection': {
      '0%': {
        transform: 'translateX(250%) skew(35deg)',
      },
      '100%': {
        transform: 'translateX(-250%) skew(35deg)',
      },
    },
    goldBorder: props => {
      const goldWithRatio = 1.05;
      const height = (() => {
        if (props.hasNoGoldBorder) return 'fit-content';
        if (props.cardHeight) return props.cardHeight * borderRatio;
        if (props.cardSize === 'extraSmall') return extraSmallCardHeight * borderRatio;
        if (props.cardSize === 'small') return smallCardHeight * borderRatio;
        if (props.cardSize === 'square') return squareCardHeight * borderRatio;
        if (props.cardSize === 'medium') return cardHeight * borderRatio;
        return '105%';
      })();

      const width = (() => {
        if (props.hasNoGoldBorder) return 'fit-content';
        if (height === '105%') return '105%';

        const h: number = height as number;
        return h * cardRatio * goldWithRatio;
      })();

      const borderRadius = (() => {
        if (props.cardSize === 'square') return 2;
        return 6;
      })();

      return {
        background: 'transparent',
        position: 'relative',
        overflow: 'hidden',
        borderRadius,
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '-webkit-mask-image':
          'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC)',
        '&:before': reflectionStyle,
        '&.show': {
          background: '#ffc11a',
        },
        '&.show:before': {
          background:
            'linear-gradient(to right, #ffc11a 0%, #ffed1a 40%, #ffed1a 60%, #ffc11a 100%)',
          animationName: '$reflection',
        },
      };
    },
    innerContainer: props => {
      const height = (() => {
        if (props.cardHeight) return props.cardHeight;
        if (props.cardSize === 'extraSmall') return extraSmallCardHeight;
        if (props.cardSize === 'square') return squareCardHeight;
        if (props.cardSize === 'small') return smallCardHeight;
        if (props.cardSize === 'medium') return cardHeight;
        if (props.cardRatio) return props.cardRatio;
        return '100%';
      })();

      const width = height === '100%' ? '100%' : height * cardRatio;

      return {
        width,
        height,
        boxShadow: '0px 0px 3px 1px #00000070',
        borderRadius: 7,
        transformStyle: 'preserve-3d',
        transition: 'transform 0.3s',
        transform: 'rotateY(180deg)',
        '&.flipped': {
          transform: 'rotateY(0deg)',
        },
        '&:before': {
          ...reflectionStyle,
          zIndex: 1,
        },
        '&.show:before': {
          background: 'rgba(255, 255, 255, 0.5)',
          animationName: '$reflection',
        },
        '&.show': {
          boxShadow: 'none',
        },
      };
    },
    cardImage: {
      width: '100%',
    },
    cardFaceCommon: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backfaceVisibility: 'hidden',
    },
    frontFace: {
      extend: 'cardFaceCommon',
    },
    backFace: {
      extend: 'cardFaceCommon',
      transform: 'rotateY(180deg)',
    },
    raised: {
      bottom: 5,
      zIndex: 1,
      position: 'relative',
    },
    darken: {
      filter: 'brightness(50%)',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
